import { ToggleableElement } from "@shared/dialogs/ToggleableDialog";
import { useEffect, useRef, useState } from "react";

export function useToggleableDialog() {
  const dialogRef = useRef<ToggleableElement | null>(null);
  // Can be used to disable queries (and possibly other background tasks) until dialog opens.
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpenDialog = () => {
    dialogRef.current?.toggleContainer(true);
  };

  const handleCloseDialog = () => {
    dialogRef.current?.toggleContainer(false);
  };

  useEffect(() => {
    const handleToggle = (e: ToggleEvent) => setIsOpen(e.newState === "open");
    const handleDialogClose = () => setIsOpen(false);

    const element = dialogRef.current;
    element?.addEventListener("toggle", handleToggle);
    element?.addEventListener("dialog-close", handleDialogClose);

    return () => {
      element?.removeEventListener("toggle", handleToggle);
      element?.removeEventListener("dialog-close", handleDialogClose);
    };
  }, [dialogRef, setIsOpen]);

  return { dialogRef, isOpen, handleOpenDialog, handleCloseDialog };
}
